import * as t from "io-ts";

export const ObjectMappingValidator = t.intersection([
  t.type({
    id: t.string,
    objectId: t.string,
    objectType: t.string,
    kind: t.string,
    key: t.string,
    value: t.string,
  }),
  t.partial({
    objectName: t.string,
    endDttm: t.number,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const ObjectMappingArrayValidator = t.array(ObjectMappingValidator);

export type ObjectMapping = t.TypeOf<typeof ObjectMappingValidator>;
export type ObjectMappingArray = t.TypeOf<typeof ObjectMappingArrayValidator>;
